import { Button } from "@/components/ui/button";

import type { Progress, RefreshSource } from "./api";
import type { RefreshState } from "./follow";
import { progressLine } from "./format";

export function RefreshButton({
  state,
  message,
  progress,
  xeroAvailable,
  onStart,
}: {
  state: RefreshState;
  message: string;
  progress: Progress;
  xeroAvailable: boolean;
  onStart: (source?: RefreshSource) => void;
}) {
  // Disabled only while a live run is followed; a stalled follow re-enables both (invariant 11).
  const running = state === "running";
  return (
    <div className="flex flex-col gap-1">
      <div className="flex flex-wrap gap-2">
        <Button onClick={() => onStart()} disabled={running} aria-busy={running}>
          {running ? "Refreshing…" : "Refresh"}
        </Button>
        {xeroAvailable ? (
          <Button variant="outline" onClick={() => onStart("xero")} disabled={running}>
            Refresh Xero stock
          </Button>
        ) : null}
      </div>
      {running ? (
        <p role="status" className="text-sm text-ks-ink">{progressLine(progress)}</p>
      ) : null}
      {message ? (
        <p
          role={state === "error" || state === "stalled" ? "alert" : "status"}
          className={`text-sm ${state === "error" ? "text-ks-danger" : "text-ks-ink"}`}
        >
          {message}
        </p>
      ) : null}
    </div>
  );
}
